
import { defineComponent } from 'vue';
import router from '@/router';
import GerenteAutenticacao from '@/core/gerentes/GerenteAutenticacao';

export default defineComponent({
  name: 'AssinaturaInativa',
  components: {

  },
  setup() {
    const gerenteAutenticacao = new GerenteAutenticacao();

    function voltar() {
      gerenteAutenticacao.removerDadosAutenticacao();
      router.push({ name: 'IdentificarAmbiente' });
    }

    return {
      voltar,
    };
  },
});
